<template>
    <Container>
        <ProgramWrapper>
            <ProgramItemLoader
                v-for="n in 9"
                :key="n" />
        </ProgramWrapper>
    </Container>
</template>

<script setup lang="ts"></script>

<style scoped></style>
